import { IInputElement } from '../../types';

import { InputTextElement } from '../../form-inputs';

type TEmailAddressInputProps = Pick<
  IInputElement,
  | 'className'
  | 'classNameInput'
  | 'classNameLabel'
  | 'error'
  | 'label'
  | 'name'
  | 'onBlurCallback'
  | 'onChangeCallback'
  | 'onError'
  | 'value'
>;

/**
 * -----------------------------------------------------------------------------
 * This is used to capture the full name of a person or organization,
 * and tries to add constraints that are used to validate the expected format of
 * a valid person's full name.
 */
export function FullNameInputField({
  className,
  classNameInput,
  classNameLabel,
  error,
  label,
  name,
  onBlurCallback,
  onChangeCallback,
  onError,
  value,
}: TEmailAddressInputProps) {
  return (
    <InputTextElement
      constraints={{
        feedbackLabel: 'Name',
        maxLength: 80,
        minLength: 3,
        required: true,
        format: 'person-fullname',
      }}
      className={className}
      classNameInput={classNameInput}
      classNameLabel={classNameLabel}
      error={error}
      hasClearButton
      label={label}
      name={name}
      onBlurCallback={onBlurCallback}
      onChangeCallback={onChangeCallback}
      onError={onError}
      placeholder="Please enter name"
      showIsRequired={false}
      type="text"
      value={value}
    />
  );
}
